import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixFieldSet } from '../Fields/PFixFieldSet';
import { AccountOperationStatisticGroup } from './AccountOperationStatisticGroup';
export class StatisticsGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.STATISTICS_GROUP, null, pfixFieldSet);
    }
    getType() {
        return this.GetValue(FieldsFactory.FIELD_TYPE);
    }
    getBeginProjectedBalance() {
        return this.GetValue(FieldsFactory.FIELD_BEGIN_PROJECTED_BALANCE);
    }
    getAccountOperationStatisticGroups() {
        return this.GetGroups(FieldsFactory.ACCOUNT_OPERATION_STATISTIC_GROUP, AccountOperationStatisticGroup);
    }
}
